// ADD TO THIS AS NEEDED

export const UID = {
  bArimoto: '1921', // brent
  cPoty1: '336', // clem
  cPoty2: '3425', // clem
  dKim: '2346', // diana
  eLi: '3375', // elson
  jZamora: '2775', // jon
  kHufford1: '747', // kenny
  kHufford2: '3377', // kenny
  mMartinez: '167', // monica
  nCuenca: '2170', // nathan
  rSingh: '4192', // ripan
  sCarr: '3155', // samantha
  tDang: '3886', // tiffany
  vChao: '2738', // vern
};

export const UX_TEAM_IDS = [UID.cPoty1, UID.cPoty2, UID.mMartinez];
